var map = {
	"./bsc.jpg": 4597,
	"./chemical.jpg": 60633,
	"./civil.jpg": 1772,
	"./convention.jpg": 75188,
	"./ece.jpg": 3684,
	"./eee.jpg": 59206,
	"./eie.jpg": 58978,
	"./enthusia.jpg": 14818,
	"./ft.jpg": 73367,
	"./hackathon.jpeg": 79455,
	"./itpark.jpg": 59418,
	"./kcc.jpg": 91016,
	"./kec.jpeg": 11143,
	"./kec.jpg": 47466,
	"./mba.jpg": 84683,
	"./mts.jpg": 4727,
	"./sports.jpeg": 47333,
	"./swaram2026.jpeg": 2127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88351;